<script lang="ts">
  import videoStore from '../../../stores/video.svelte'
  import ControlBar from '../ControlBar.svelte'
  import PlayPauseButton from '../buttons/PlayPauseButton.svelte'
  import SeekBackwardButton from '../buttons/SeekBackwardButton.svelte'
  import SeekForwardButton from '../buttons/SeekForwardButton.svelte'
  import VolumeButton from '../buttons/VolumeButton.svelte'
  import AirPlayButton from '../buttons/AirPlayButton.svelte'
  import ChromecastButton from '../buttons/ChromecastButton.svelte'
  import SettingsButton from '../buttons/SettingsButton.svelte'
  import ChaptersButton from '../buttons/ChaptersButton.svelte'
  import SummaryButton from '../buttons/SummaryButton.svelte'
  import CaptionsButton from '../buttons/CaptionsButton.svelte'
  import FullscreenButton from '../buttons/FullscreenButton.svelte'
  import PiPButton from '../buttons/PiPButton.svelte'
  import { CONTROL_BAR_BUTTON_TOOLTIP_POSITION } from '../buttons/ControlBarButton.svelte'
</script>

<ControlBar>
  {#snippet left()}
    <PlayPauseButton
      tooltipPosition={CONTROL_BAR_BUTTON_TOOLTIP_POSITION.LEFT}
    />
    <SeekBackwardButton />
    <SeekForwardButton />
    <VolumeButton />
  {/snippet}
  {#snippet right()}
    <AirPlayButton />
    <ChromecastButton
      tooltipPosition={videoStore.state.isChromecasting
        ? CONTROL_BAR_BUTTON_TOOLTIP_POSITION.RIGHT
        : CONTROL_BAR_BUTTON_TOOLTIP_POSITION.CENTER}
    />
    <SettingsButton />
    <ChaptersButton />
    <SummaryButton />
    <CaptionsButton />
    <FullscreenButton
      tooltipPosition={!videoStore.state.isPicureInPictureSupported
        ? CONTROL_BAR_BUTTON_TOOLTIP_POSITION.RIGHT
        : CONTROL_BAR_BUTTON_TOOLTIP_POSITION.CENTER}
    />
    <PiPButton tooltipPosition={CONTROL_BAR_BUTTON_TOOLTIP_POSITION.RIGHT} />
  {/snippet}
</ControlBar>
